import { Directive, ElementRef, HostListener, inject, Input, OnInit } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Directive({
  selector: '[appTruncatedText]',
  standalone: true,
  hostDirectives: [MatTooltip] 
})
export class TruncatedTextDirective implements OnInit {
  @Input('appTruncatedText') tooltipText: string = '';
  @Input() maxWidth: string = '100%';

  private tooltip = inject(MatTooltip);
  private el = inject(ElementRef);

  ngOnInit() {
    const s = this.el.nativeElement.style;
    s.display = 'block';
    s.whiteSpace = 'nowrap';
    s.overflow = 'hidden';
    s.textOverflow = 'ellipsis';
    s.maxWidth = this.maxWidth;
  }

  @HostListener('mouseenter')
  onMouseEnter() {
    const element = this.el.nativeElement;
    if (element.scrollWidth > element.clientWidth) {
      this.tooltip.message = this.tooltipText;
      this.tooltip.disabled = false;
      this.tooltip.show();
    } else {
      this.tooltip.disabled = true;
    }
  }
}
